import React, { useEffect, useRef, useState } from "react";
import Fileupload from "../components/Fileupload";
import {
  fileDelete,
  get_prev_files,
  getdownload,
  reportValidation,
  sendDataToApi,
} from "../api/api";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "../components/Modal";
import LoadingScreen from "react-loading-screen";

const Dashboard = ({
  apiData,
  renderpage,
  setSelected,
  setFileId,
  completed,
  setCompleted,
}) => {
  const navigate = useNavigate();
  const bordercolors = [
    "rgba(255, 106, 0, 0.6)",
    "rgba(85, 31, 255, 0.6)",
    "rgba(0, 183, 254, 0.6)",
    "rgba(253, 34, 84, 0.6)",
  ];
  // const [files, setFiles] = useState([]);
  const [dropDown, setDropdown] = useState({});
  const [selectedData, setSelectedData] = useState({
    process: "",
  });
  const [prevfiles, setPrevFiles] = useState([]);
  const dropdownRef = useRef(null);
  const [downloaddata, setdownloaddata] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [fileToDelete, setFileToDelete] = useState();
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const isDownloadRef = useRef([]);
  const [, forceUpdate] = useState(0);
  // useeffect to detect click outside the dropdown
  const { pages } = useParams();

  // useEffect(() => {
  //   if (pages === "dashboard") {
  //     navigate("/accessibility_epub/dashboard", { replace: true });
  //   }
  // }, [pages, navigate]);

  // console.log(window.location.href);

  useEffect(() => {
    window.history.pushState(null, null, window.location.href);

    const handleBackButton = (event) => {
      window.history.pushState(null, null, window.location.href);
      // toast.warn("Going back is restricted");

      window.history.pushState(null, null, window.location.href);
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !event.target.closest(".togglebtn")
      ) {
        setDropdown({}); // Close any open dropdown if clicking outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  // Getting the data for select from api

  useEffect(() => {
    fetchprevfiles("dashboard");
  }, []);

  useEffect(() => {
    if (completed) {
      fetchprevfiles("dashboard");
      setCompleted(false);
    }
  }, [completed]);

  useEffect(() => {
    setSelected(selectedData.process);
  }, [selectedData, setSelected]);

  const fetchprevfiles = async (process) => {
    try {
      let data = await get_prev_files(process);
      if (data.data) {
        setPrevFiles(data.data);
      } else {
        // alert(data.error);
        toast.error(data.error.message);
      }
    } catch (e) {
      // alert(e);
      toast.error(e);
    }
  };
  const btnref = useRef();

  const toggleDownload = (fileid) => {
    if (isDownloadRef.current.includes(fileid)) {
      isDownloadRef.current = isDownloadRef.current.filter(
        (id) => id !== fileid
      );
    } else {
      isDownloadRef.current.push(fileid);
    }
    forceUpdate((prev) => prev + 1);
  };

  const senddata = async (event) => {
    // Store the current target to ensure it remains accessible
    const button = event.currentTarget;
    button.disabled = true; // Disable the button
    document.body.style.cursor = "wait"; // Show a loading cursor

    if (selectedData.filename.length > 0) {
      event.currentTarget.disabled = true;
      document.body.style.cursor = "wait";

      // Set a timeout to handle API delay
      // const timeoutDuration = 10000; // 10 seconds
      // const timeout = setTimeout(() => {
      //   document.body.style.cursor = "default";
      //   button.disabled = false; // Re-enable the button
      //   alert("The request timed out. Please try again.");
      // }, timeoutDuration);
      if (selectedData.process[1].length === 0) {
        setShowValidationModal(true);
      } else {
        try {
          let response = await sendDataToApi(selectedData);
          // Clear timeout if API responds in time
          // clearTimeout(timeout);

          if (response.data) {
            document.body.style.cursor = "default";
            handleNext(response.data.file_id, response.data.next_process);
          } else {
            // alert(response.error.message);
            toast.error(response.error.message);
            // console.log(response.error.message);
            document.body.style.cursor = "default";
            button.disabled = false; // Re-enable the button
          }
        } catch (apiError) {
          // clearTimeout(timeout);
          document.body.style.cursor = "default";
          button.disabled = false; // Re-enable the button
          console.error(apiError);
          toast.error("An error occured. Please try again.");
          // alert("An error occurred. Please try again.");
        }
      }
    } else {
      // Handle the case when no file is selected
      // alert("Please upload a file to proceed.");
      toast.error("Please upload a file to proceed");
      document.body.style.cursor = "default";
      button.disabled = false; // Re-enable the button
    }
  };

  const handleNext = (fileId, nextpage) => {
    renderpage(fileId, nextpage);
  };

  useEffect(() => {
    if (apiData) {
      // Create a dictionary where each ID maps to its step values
      const initialSelectedData = apiData.reduce((acc, item) => {
        acc.filename = "";
        acc.content = "";
        acc.process = acc.process || {};
        acc.process[item.id] = item.steps.map((step) => Object.keys(step)[0]); // Extract step values
        return acc;
      }, {});

      setSelectedData(initialSelectedData);
    }
  }, [apiData]);

  const handleDropDown = (title) => {
    setDropdown((prev) => ({ [title]: !prev[title] }));
  };

  const handleChange = (heading, input) => {
    setSelectedData((prev) => {
      const currentValues = prev.process[heading] || [];
      console.log(currentValues);

      const updatedValues = currentValues.includes(input)
        ? currentValues.filter((value) => value !== input) // Remove the value if it already exists
        : [...currentValues, input]; // Add the value if it doesn't exist
      // Return the updated state
      return {
        ...prev,
        process: { ...prev.process, [heading]: updatedValues },
      };
    });
  };

  const handleall = (id, steps) => {
    setSelectedData((prev) => {
      const currentValues = prev.process[id] || [];

      const stepValues = steps.map((item) => Object.keys(item)[0]);

      // console.log(stepValues);

      const areAllSelected = stepValues.every((stepValues) =>
        currentValues.includes(stepValues)
      );

      const updatedValues = areAllSelected
        ? [] // Deselect all if already selected
        : steps.map((item) => Object.keys(item)[0]); // Select all

      console.log(updatedValues);

      return {
        ...prev,
        process: {
          ...prev.process,
          [id]: updatedValues, // Update the selected steps for this process
        },
      };
    });
  };

  const handleFileNav = (files) => {
    renderpage(files.file_id, files.next_process);
  };

  const downloadreport = (data, filename, fileid) => {
    try {
      const file = data;
      const byteCharacters = atob(file);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      // console.log(byteArrays);
      const blob = new Blob(byteArrays, { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      downloadfile(url, filename, fileid);
    } catch (e) {
      console.log(e);
    }
  };

  const handleDownload = async (fileid, process) => {
    try {
      toggleDownload(fileid);
      let data = await getdownload(fileid, process);
      if (data.data) {
        // console.log(data.data);
        downloadreport(data.data.content, data.data.file_name, fileid);
      } else if (data.error && typeof data.error === "object") {
        const firstMessage = Object.values(data.error)[0];
        toggleDownload(fileid);

        toast.error(firstMessage);
      }
    } catch (e) {
      // alert(e);
      toast.error(e);
    }
  };

  const downloadfile = (url, filename, fileid) => {
    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `${filename}`; // You can specify the name of the file here
      link.click();
      // Clean up the URL object
      window.URL.revokeObjectURL(url);
      if (fileid) {
        toggleDownload(fileid);
      }
    } else {
      // alert("No File to Download");
      toast.info("No Files to Download");
    }
  };

  const handleFileDelete = async (fileid, filename) => {
    setShowModal(true);
    setFileToDelete({ fileid: fileid, filename: filename });
  };

  const confirmFileDelete = async () => {
    if (fileToDelete) {
      let response = await fileDelete(fileToDelete.fileid, "dashboard");
      if (response.data) {
        toast.success(response.data.message);

        fetchprevfiles("dashboard");
      } else {
        // alert(response.error.message);
        toast.error(response.error.message);
      }
    }
  };

  console.log(btnref);

  const runInBg = async () => {
    setShowValidationModal(false);
    document.body.style.cursor = "wait";
    try {
      let response = await sendDataToApi(selectedData);
      if (response.data) {
        document.body.style.cursor = "default";
        btnref.current.disabled = false;
        setTimeout(() => {
          fetchprevfiles("dashboard");
        }, 2000);
        let response1 = await reportValidation(response.data);
        if (response1.data) {
          setCompleted(true);
        }
      } else {
        toast.error(response.error.message);
        document.body.style.cursor = "default";
        btnref.current.disabled = false;
      }
    } catch (e) {
      toast.error(e);
    }
  };

  const runInloading = async () => {
    // console.log("run in loading");
    setLoading(true);
    try {
      let response = await sendDataToApi(selectedData);
      if (response.data) {
        let response1 = await reportValidation(response.data);
        if (response1.data) {
          setCompleted(true);
          handleDownload(response.data.file_id);
        }
        setLoading(false);
        document.body.style.cursor = "default";
        navigate("/accessibility_epub/dashboard");
      } else {
        toast.error(response.error.message);
        setLoading(false);
        document.body.style.cursor = "default";
      }
    } catch (e) {
      toast.error(e);
    }
  };

  // console.log(prevfiles);

  return (
    <LoadingScreen
      loading={loading}
      bgColor="#f1f1f1"
      spinnerColor="#1A53A9"
      textColor="#1A53A9"
      text="Processing file please wait ...."
    >
      <div className="h-full w-full flex flex-col">
        {apiData ? (
          <div className="p-8 flex flex-col gap-8 h-[100%]">
            <div className="text-left">
              <h1 className="text-24 font-semibold">Heading</h1>
            </div>
            <div className="grid grid-cols-2  md:grid-cols-4 gap-4">
              {apiData?.map((list, i) => (
                <div
                  key={i}
                  className="flex flex-col px-6 py-4 text-left rounded-[16px] border-[1px] bg-white relative"
                  style={{
                    borderColor: `${bordercolors[i]}`,
                    boxShadow: "0px 0px 14px rgba(201, 195, 193, 0.25)",
                  }}
                >
                  <h1 className="text-18 font-semibold mb-2">{list.title}</h1>
                  <hr className="border-[1px] border-commonborder border-dashed"></hr>
                  <button
                    onClick={(i) => handleDropDown(list.id)}
                    className="w-full flex justify-between mt-4 text-subtitle togglebtn"
                  >
                    View List{" "}
                    <span>
                      <img
                        src={
                          process.env.PUBLIC_URL + "/images/viewlistarrow.svg"
                        }
                        className={`transition-rotate duration-300 ${
                          dropDown[list.id] ? "rotate-[90deg]" : "rotate-[0deg]"
                        }`}
                        alt="open_list"
                      />
                    </span>
                  </button>
                  {dropDown[list.id] && (
                    <div
                      ref={dropdownRef}
                      className="absolute h-fit w-full bg-white top-[110%] left-0 rounded-[16px] overflow-hidden border-[1px] border-commonborder"
                    >
                      <div className="max-h-[500px]">
                        <div className="px-3 pr-4 py-6 flex justify-between bg-dropdownfill sticky top-0">
                          <p>{list.title}</p>
                          <input
                            type="checkbox"
                            onChange={() => handleall(list.id, list.steps)}
                            checked={list.steps.every((step) =>
                              selectedData.process[list.id]?.includes(
                                Object.keys(step)[0]
                              )
                                ? "checked"
                                : ""
                            )}
                          />
                        </div>

                        <ul className="max-h-[350px] overflow-auto">
                          {list.steps.length > 0 &&
                            list.steps.map((step, i) => {
                              const stepValue = Object.keys(step)[0];

                              return (
                                <div
                                  key={i}
                                  className="flex px-3 py-4 justify-between"
                                >
                                  <li>{Object.values(step)[0]}</li>
                                  <input
                                    onChange={() =>
                                      handleChange(list.id, stepValue)
                                    }
                                    value={stepValue}
                                    type="checkbox"
                                    checked={selectedData.process[
                                      list.id
                                    ]?.includes(stepValue)}
                                  />
                                </div>
                              );
                            })}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <Fileupload
              // file={files}
              // setFiles={setFiles}
              setSelectedData={setSelectedData}
            />

            <button
              ref={btnref}
              onClick={(event) => {
                senddata(event);
              }}
              className="w-fit ml-auto mt-20 flex justify-end"
            >
              <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
                NEXT
              </p>
            </button>
            <div className="w-full">
              {prevfiles?.length > 0 && (
                <div className="">
                  <div className="w-full flex justify-start">
                    <h1 className="text-24 font-semibold">Previous Files</h1>
                  </div>
                  <div className=" rounded-[16px] border-[1px] border-commonborder shadow-commonshadow mt-10 overflow-auto max-h-[600px]">
                    <table className="w-full">
                      <thead className="sticky top-0 z-10 bg-tableheadingbg px-4 py-6 text-left text-white text-16 font-semibold w-full">
                        <tr>
                          <th className="px-4 py-5">S.No</th>
                          <th className="px-4 py-5">File Name</th>
                          <th className="px-4 py-5">File Uploaded on</th>
                          <th className="px-4 py-5">Download Report</th>
                          <th className="px-4 py-5">Status</th>
                          <th className="px-4 py-5">Delete</th>
                        </tr>
                      </thead>
                      <tbody className="w-full text-left bg-white">
                        {prevfiles.map((files, i) => (
                          <tr
                            key={i}
                            className="border-b-[1px] border-commonborder last:border-none"
                          >
                            <td className="px-4 py-5">{i + 1}</td>
                            <td className="px-4 py-5">{files.file_name}</td>
                            <td className="px-4 py-5">{files.date}</td>
                            <td className="px-4 py-5">
                              <button
                                className=""
                                disabled={
                                  files.file_status === "0" ||
                                  files.file_status === "2" ||
                                isDownloadRef.current.includes(files.file_id)
                                }
                               
                                onClick={() => {
                                if (
                                  !isDownloadRef.current.includes(files.file_id)
                                ) {
                                  handleDownload(files.file_id, "dashboard")
                                }
                              }}
                              >
                                <p
                                  className={`${
                                    files.file_status === "1"
                                      ? "text-highlight"
                                      : "text-gray opacity-[70%]"
                                  }`}
                                >
                                 {isDownloadRef.current.includes(files.file_id)
                                  ? "Downloading..."
                                  : "Download"}
                                </p>
                              </button>
                            </td>
                            <td className="px-4 py-5">
                              <div
                                className={`w-fit px-4 py-1 rounded-[12px] text-white font-regular ${
                                  files.file_status === "0"
                                    ? "bg-highlight"
                                    : files.file_status === "1"
                                    ? "bg-[#008000]"
                                    : "bg-[#f89611]"
                                }`}
                              >
                                {files.file_status === "0" ? (
                                  <button
                                    className="py-1"
                                    onClick={() => handleFileNav(files)}
                                  >
                                    {`Resume ${files.resume_process}`}
                                  </button>
                                ) : files.file_status === "1" ? (
                                  <div className="py-1">Completed</div>
                                ) : (
                                  <div className="py-1">Processing...</div>
                                )}
                              </div>
                            </td>
                            <td className="px-4 py-5">
                              <button
                                onClick={() =>
                                  handleFileDelete(
                                    files.file_id,
                                    files.file_name
                                  )
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="red"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="icon icon-tabler icons-tabler-outline icon-tabler-trash"
                                >
                                  <path
                                    stroke="none"
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  />
                                  <path d="M4 7l16 0" />
                                  <path d="M10 11l0 6" />
                                  <path d="M14 11l0 6" />
                                  <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                  <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* {prevfiles.map((files, i) => (
                  <div
                    key={i}
                    className="w-full max-h-[500px] overflow-auto mt-6 bg-white overflow-hidden rounded-[12px]"
                  >
                    <div className="p-6 border-[1px] border-C4C6CC rounded-[12px] bg-F8F9FA">
                      <div className="border-[1px] border-highlight border-dashed py-4 flex flex-col justify-center w-full items-center rounded-[16px]">
                        <div className="flex w-full px-4 items-center justify-between">
                          <div className="flex items-center justify-between gap-4">
                            <span className="w-8 h-8">
                              <img
                                alt="epub_logo"
                                src={
                                  process.env.PUBLIC_URL + "/images/epub.svg"
                                }
                                className="w-full h-full object-cover"
                              ></img>
                            </span>
                            <div className="flex flex-col items-start">
                              <p>{files.file_name}</p>
                            </div>
                          </div>
                          <div className="flex gap-5">
                            {files.file_status === "1" && (
                              <button
                                onClick={() => handleDownload(files.file_id)}
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/images/downloadicon.svg"
                                  }
                                  alt="download"
                                ></img>
                              </button>
                            )}
                          <div
                            className={`w-fit px-4 py-1 rounded-[4px] text-white font-semibold ${
                              files.file_status === "0"
                                ? "bg-highlight"
                                : "bg-[#008000]"
                            }`}
                          >
                              <button
                                onClick={
                                  files.file_status === "0"
                                    ? () => handleFileNav(files)
                                    : undefined
                                }
                              >
                              {files.file_status === "0"
                                ? "Resume Processing"
                                : "Completed"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                ))} */}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="w-full h-[80vh] flex items-center justify-center">
            <div>
              <h1>Problem connecting with network!</h1>
              <p>Check your connection or contact system Administrator</p>
            </div>
          </div>
        )}
        {showModal && (
          <div>
            <Modal
              title={"Alert"}
              body={`Do you wish to delete file ${fileToDelete?.filename} ?`}
              setShow={setShowModal}
              setConfirm={confirmFileDelete}
              confirmbtn={"Confirm"}
              cancelbtn={"Cancel"}
            />
          </div>
        )}
        {showValidationModal && (
          <Modal
            title={"Alert"}
            body={
              "Do you wish to continue the processing in the Background and continue to Dashboard ?"
            }
            setShow={setShowValidationModal}
            setConfirm={runInBg}
            setSecondary={runInloading}
            cancelbtn={"Cancel"}
            confirmbtn={"Run in Background"}
            secondarybtn={"Continue to Loading screen"}
            // setbackground={setRunInBackground}
          />
        )}
      </div>
    </LoadingScreen>
  );
};

export default Dashboard;
